/**
 * @description: 会员生日报表
 * @author: hwx
*/
<template>
    <div class="mr-hsr-report">
        <div class="member-bd-list">
            <div class="row row-margin">
                <label class="list-label-4">生日查询:</label>
                <div class="col-md-3 list-time">
                    <div ref="bdTime">
                        <input type="text" class="form-control laydate-icon" v-model="bdStartTime" /> -
                        <input type="text" class="form-control laydate-icon" v-model="bdEndTime" />
                    </div>
                </div>
                <label class="list-label-2">门店:</label>
                <div class="col-md-2 ct-col">
                    <select class="form-control" ref="bdShop" data-placeholder="请选择门店"></select>
                </div>
                <div class="col-md-1 ct-col jh-tit-sel">
                    <select class="form-control" ref="bdQuery_conditions">
                        <option value="kh_id">会员卡号</option>
                        <option value="phone_numb">会员手机号</option>
                        <option value="wechat_name">微信昵称</option>
                    </select>
                </div>
                <div class="col-md-2 jh-con-val">
                    <input type="text" class="form-control" v-model="bdSearch_info" :placeholder="bdEmployeeinput">
                </div>
            </div>
            <div class="row row-margin">
                <div class="pull-right">
                    <button type="button" class="btn btn-flat btn-small btn-border-gray btn-orange" ref="bd_fast_month" @click="bdBirthFast('本月')">本月生日</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" ref="bd_fast_week" @click="bdBirthFast('本周')">本周生日</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" ref="bd_fast_today" @click="bdBirthFast('本日')">本日生日</button>
                    <button type="button" class="btn btn-flat btn-small btn-border-gray" @click="getBdExportSet">导出</button>
                    <button type="button" class="btn btn-flat btn-small btn-orange" @click="innitBdTable">查询</button>
                </div>
            </div>
            <div class="row row-margin">
                <label class="list-label-4">生日人数:</label>
                <div class="list-total" ref="bd_total"></div>
            </div>
            <div class="table-responsive">
                <table class="table table-bordered table-hover" data-pagination="true" ref="bdList"></table>
            </div>
            <!-- 导出设置弹窗 -->
            <div class="ele-hide" ref="bdExport_alert">
                <div class="set-export sel-seldiv">
                    <h3>请选择导出报表需要的显示的字段</h3>
                    <ul class="set-area clearfix">
                        <li>
                            <input type='checkbox' v-model='bdExport_allcheck' @click='bdExportCheckedAll'>
                            <label>全选</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='bdExport_checkModel' value="shop_name">
                            <label>门店</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='bdExport_checkModel' value="nickname">
                            <label>微信昵称</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='bdExport_checkModel' value="vip_card">
                            <label>会员卡号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='bdExport_checkModel' value="mobile">
                            <label>会员手机号</label>
                        </li>
                        <li>
                            <input type="checkbox" v-model='bdExport_checkModel' value="birthday">
                            <label>生日</label>
                        </li>
                    </ul>
                    <h3>请选择导出报表的文件格式</h3>
                    <ul class="clearfix">
                        <li>
                            <input type="radio" v-model='bdExport_type' value="1">
                            <label>excel表格</label>
                        </li>
                        <li>
                            <input type="radio" v-model='bdExport_type' value="2">
                            <label>pdf文件</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                bdStartTime: "",
                bdEndTime: "",
                bdEmployeeinput: '请输入会员卡号',
                bdSearch_field: "kh_id",
                bdSearch_info: "",
                bdTodayStar: "",
                bdTodayEnd: "",
                bdWeekStar: "",
                bdWeekEnd: "",
                bdMonthStar: "",
                bdMonthEnd: "",
                bdExport_allcheck: false,
                c_bdExport_allcheck: false,
                bdExport_checkModel: [],
                bdExport_checkData: ['shop_name', 'nickname', 'vip_card', 'mobile', 'birthday'],
                bdExport_type: 1,
            }
        },
        watch: {
            bdExport_checkModel: {
                handler: function (val, oldVal) {
                    if(this.bdExport_checkModel.length >= this.bdExport_checkData.length) {
                        this.bdExport_allcheck = true;
                        this.c_bdExport_allcheck = true;
                    } else {
                        this.bdExport_allcheck = false;
                        this.c_bdExport_allcheck = false;
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            const _this = this
            _this.getToday();
            _this.getWeek(0);
            _this.getMonthStartAndEnd(0);
            _this.bdStartTime = _this.bdMonthStar;
            _this.bdEndTime = _this.bdMonthEnd;
            $(_this.$refs.bd_fast_month).removeClass('btn-orange');
            $(_this.$refs.bd_fast_week).removeClass('btn-orange');
            $(_this.$refs.bd_fast_today).removeClass('btn-orange');
            $(_this.$refs.bd_fast_month).addClass('btn-orange');
            _this.initBdBirthday();
            _this.shopDatas = [];
            _this.innitInput();  // 门店
            // 下拉选项
            $(_this.$refs.bdQuery_conditions).select2({
                language: "zh-CN",
                minimumResultsForSearch: -1
            }).change(function() {
                _this.bdSearch_field = $(this).val();
                if(_this.bdSearch_field == 'kh_id') {
                    _this.bdEmployeeinput = '请输入会员卡号';
                } else if(_this.bdSearch_field == 'phone_numb') {
                    _this.bdEmployeeinput = '请输入会员手机号';
                } else if(_this.bdSearch_field == 'wechat_name') {
                    _this.bdEmployeeinput = '请输入微信昵称';
                }
            });
        },
        methods: {
            // 初始化门店输入框
            innitInput: function() {
                let _this = this;

                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "page": "1",
                            "page_size": "0",
                            "name": "",
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            $.each(data.response.result, function(k, v) {
                                _this.shopDatas.push({
                                    id: v.id,
                                    text: v.name
                                });
                            });
                            $(_this.$refs.bdShop).select2({
                                data: _this.shopDatas,
                                allowClear: true,
                                minimumResultsForSearch: -1,
                                language: "zh-CN"
                            });
                            $(_this.$refs.bdShop).val(data.response.result[1].id).trigger('change');
                            _this.innitBdTable();
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },



            // 日期格式化
            formatDate: function(mydate) {
                let str = "";
                if(mydate.getMonth() + 1 < 10) {
                    str += '0' + (mydate.getMonth() + 1) + '-';
                } else {
                    str += (mydate.getMonth() + 1) + '-';
                }
                if(mydate.getDate() < 10) {
                    str += '0' + mydate.getDate();
                } else {
                    str += mydate.getDate();
                }
                return str;
            },
            // 本日
            getToday: function() {
                let myDate = new Date();
                let intEndTime = myDate;

                this.bdTodayStar = this.formatDate(intEndTime);
                this.bdTodayEnd = this.formatDate(intEndTime);
            },
            // 本周
            getWeek: function(AddWeekCount) {
                // 一天的毫秒数
                let millisecond = 1000 * 60 * 60 * 24;
                // 获取当前时间
                let currentDate = new Date();
                // 相对于当前日期AddWeekCount个周的日期
                currentDate = new Date(currentDate.getTime() + (millisecond * 7 * AddWeekCount));
                // 返回date是一周中的某一天
                let week = currentDate.getDay();
                // 返回date是一个月中的某一天
                let month = currentDate.getDate();
                // 减去的天数
                let minusDay = week != 0 ? week - 1 : 6;
                // 获得当前周的第一天
                let currentWeekFirstDay = new Date(currentDate.getTime() - (millisecond * minusDay));
                // 获得本周的最后一天
                let currentWeekLastDay = new Date(currentWeekFirstDay.getTime() + (millisecond * 6));

                this.bdWeekStar = this.formatDate(currentWeekFirstDay);
                this.bdWeekEnd = this.formatDate(currentWeekLastDay);
            },
            // 本月
            getMonthStartAndEnd: function(AddMonthCount) {
                // 获取当前时间
                let currentDate = new Date();
                let month = currentDate.getMonth() + AddMonthCount;
                if(month < 0) {
                    let n = parseInt((-month) / 12);
                    month += n * 12;
                    currentDate.setFullYear(currentDate.getFullYear() - n);
                }
                currentDate = new Date(currentDate.setMonth(month));
                // 获得当前月份0-11
                let currentMonth = currentDate.getMonth();
                // 获得当前年份4位年
                let currentYear = currentDate.getFullYear();
                // 获得本月的第一天
                let currentMonthFirstDay = new Date(currentYear, currentMonth, 1);
                // 获得下个月的第一天
                let currentMonthLastDay = new Date(currentYear, currentMonth + 1, 0);

                this.bdMonthStar = this.formatDate(currentMonthFirstDay);
                this.bdMonthEnd = this.formatDate(currentMonthLastDay);
            },
            // 生日
            initBdBirthday: function() {
                let _this = this;
                $(_this.$refs.bdTime).daterangepicker({

                    showDropdowns: true,
                    showSelectYear: false,
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    // startDate: _this.IntstartTime,
                    // endDate: _this.IntendTime
                }, function(start, end, label) {
                    $(_this.$refs.bd_fast_month).removeClass('btn-orange');
                    $(_this.$refs.bd_fast_week).removeClass('btn-orange');
                    $(_this.$refs.bd_fast_today).removeClass('btn-orange');
                    _this.bdStartTime = start.format('MM-DD');
                    _this.bdEndTime = end.format('MM-DD');
                });
            },
            // 快捷日期
            bdBirthFast: function(type) {
                let _this = this;
                $(_this.$refs.bd_fast_month).removeClass('btn-orange');
                $(_this.$refs.bd_fast_week).removeClass('btn-orange');
                $(_this.$refs.bd_fast_today).removeClass('btn-orange');
                if(type == '本月') {
                    $(_this.$refs.bd_fast_month).addClass('btn-orange');
                    _this.bdStartTime = _this.bdMonthStar;
                    _this.bdEndTime = _this.bdMonthEnd;
                    _this.innitBdTable();
                } else if(type == '本周') {
                    $(_this.$refs.bd_fast_week).addClass('btn-orange');
                    _this.bdStartTime = _this.bdWeekStar;
                    _this.bdEndTime = _this.bdWeekEnd;
                    _this.innitBdTable();
                } else if(type == '本日') {
                    $(_this.$refs.bd_fast_today).addClass('btn-orange');
                    _this.bdStartTime = _this.bdTodayStar;
                    _this.bdEndTime = _this.bdTodayEnd;
                    _this.innitBdTable();
                }
            },
            // 初始化会员生日报表
            innitBdTable: function() {
                let _this = this;
                $(_this.$refs.bdList).bootstrapTable('destroy');
                $(_this.$refs.bdList).bootstrapTable({
                    pageNumber: 1,
                    pageSize: 10,
                    pageList: [],
                    pagination: true,
                    ajax: function(params) {
                        _this.getBdList(params);
                    },
                    sidePagination: "server",
                    columns: [{
                        field: "index",
                        title: "行号",
                        width: "5%",
                        valign: "middle",
                        formatter: function(value, row, index) {
                            return index + 1;
                        }
                    }, {
                        field: "shop_name",
                        title: "门店",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "nickname",
                        title: "微信昵称",
                        width: "6%",
                        valign: "middle"
                    }, {
                        field: "vip_card",
                        title: "会员卡号",
                        width: "10%",
                        valign: "middle"
                    }, {
                        field: "mobile",
                        title: "会员手机号",
                        width: "12%",
                        valign: "middle"
                    }, {
                        field: "birthday",
                        title: "生日",
                        width: "8%",
                        valign: "middle"
                    }]
                });
            },
            // 获取会员生日报表
            getBdList: function(params) {
                let _this = this,
                    shop_id = $(_this.$refs.bdShop).val(),
                    pageNumber = 1;
                if(params != "" && params.data.offset != 0) {
                    pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
                }
                let datas;
                if(_this.bdSearch_field == 'kh_id') {
                    datas = {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "page": pageNumber,
                                "page_size": params.data.limit,
                                "shop_id": shop_id,
                                "vip_card": _this.bdSearch_info,
                                "birthday_start_time": _this.bdStartTime,
                                "birthday_end_time": _this.bdEndTime
                            }
                        },
                        "comment": ""
                    };
                } else if(_this.bdSearch_field == 'phone_numb') {
                    datas = {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "page": pageNumber,
                                "page_size": params.data.limit,
                                "shop_id": shop_id,
                                "mobile": _this.bdSearch_info,
                                "birthday_start_time": _this.bdStartTime,
                                "birthday_end_time": _this.bdEndTime
                            }
                        },
                        "comment": ""
                    };
                } else if(_this.bdSearch_field == 'wechat_name') {
                    datas = {
                        "header": Vue.request_header,
                        "request": {
                            "version": Vue.version,
                            "param": {
                                "page": pageNumber,
                                "page_size": params.data.limit,
                                "shop_id": shop_id,
                                "nickname": _this.bdSearch_info,
                                "birthday_start_time": _this.bdStartTime,
                                "birthday_end_time": _this.bdEndTime
                            }
                        },
                        "comment": ""
                    };
                }
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getVipHabitsList",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            params.success({
                                total: data.response.result.total,
                                rows: data.response.result.rows
                            });
                            $(_this.$refs.bd_total).text(data.response.result.total);
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                            params.success({
                                total: 0,
                                rows: 0
                            });
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });
            },
            // 获取导出设置
            getBdExportSet: function() {
                let _this = this;
                let datas = {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "report_type": "FinanceReport/vipBirthdayExport"
                        }
                    },
                    "comment": ""
                };
                let datas2 = JSON.stringify(datas);
                $.ajax({
                    type: "post",
                    dataType: "json",
                    url: Vue.ctUrl + "FinanceReport/getExportSet",
                    crossDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    data: datas2,
                    success: function(data) {
                        if(data.response.result_code == "true") {
                            if(data.response.result) {
                                _this.bdExport_checkModel = data.response.result.export_fields;
                                _this.bdExport_type = data.response.result.export_type;
                            } else {
                                _this.bdExport_checkModel = _this.bdExport_checkData;
                                _this.bdExport_type = 1;
                            }
                        } else {
                            Vue.timeoutfun(data.response.result_status, _this);
                            layer.msg(data.response.error_msg);
                        }
                    },
                    error: function(err) {
                        layer.msg("出错啦");
                    }
                });

                // 弹窗
                layer.confirm('', {
                    skin: 'add_printer_area',
                    type: 1,
                    btn: ['确定', '取消'], // 按钮
                    title: ['导出设置', true],
                    area: ['830px', ''], // 宽高
                    content: $(_this.$refs.bdExport_alert)
                }, function() {
                    _this.exportBdList();
                });
            },
            // 导出字段全选
            bdExportCheckedAll: function() {
                let _this = this;
                _this.bdExport_allcheck = _this.c_bdExport_allcheck;
                if(!_this.bdExport_allcheck) { // 实现全选
                    _this.bdExport_checkModel = [];
                    _this.bdExport_checkData.forEach(function(item) {
                        _this.bdExport_checkModel.push(item);
                    });
                } else { // 实现反选
                    _this.bdExport_checkModel = [];
                }
            },
            // 点击“导出”
            exportBdList: function() {
                let _this = this,
                    shop_id = $(_this.$refs.bdShop).val();
                let export_fields = JSON.stringify(_this.bdExport_checkModel);
                if(_this.bdSearch_field == 'kh_id') {
                    window.location.href = Vue.ctUrl + "FinanceReport/vipHabitsExport?page_type=birthday" +
                        "&shop_id=" + shop_id +
                        "&vip_card=" + _this.bdSearch_info +
                        "&birthday_start_time=" + _this.bdStartTime +
                        "&birthday_end_time=" + _this.bdEndTime +
                        "&export_fields=" + export_fields +
                        "&export_type=" + _this.bdExport_type;
                } else if(_this.bdSearch_field == 'phone_numb') {
                    window.location.href = Vue.ctUrl + "FinanceReport/vipHabitsExport?page_type=birthday" +
                        "&shop_id=" + shop_id +
                        "&mobile=" + _this.bdSearch_info +
                        "&birthday_start_time=" + _this.bdStartTime +
                        "&birthday_end_time=" + _this.bdEndTime +
                        "&export_fields=" + export_fields +
                        "&export_type=" + _this.bdExport_type;
                } else if(_this.bdSearch_field == 'wechat_name') {
                    window.location.href = Vue.ctUrl + "FinanceReport/vipHabitsExport?page_type=birthday" +
                        "&shop_id=" + shop_id +
                        "&nickname=" + _this.bdSearch_info +
                        "&birthday_start_time=" + _this.bdStartTime +
                        "&birthday_end_time=" + _this.bdEndTime +
                        "&export_fields=" + export_fields +
                        "&export_type=" + _this.bdExport_type;
                }
                //debugger;
                layer.msg("导出成功！");
                layer.closeAll();
            },
        }
    }
</script>
<style lang="less" scoped>
    .member-bd-list {
        .pull-right {
            button {
                margin-left: 10px;
            }
        }
    }
</style>